/* eslint-disable arrow-body-style */
export default function useValidators(): {
  isEmpty: (fieldName: string, fieldValue: string) => string;
  isEmptyDate: (fieldName: string, fieldValue: Date|undefined) => string;
  isEmptyNumber: (fieldName: string, fieldValue: number) => string;
  minLength: (fieldName: string, fieldValue: string, min: number) => string;
  isEmail: (fieldName: string, fieldValue: string) => string;
  isNum: (fieldName: string, fieldValue: string) => string;
  regExTest: (fieldValue: string, regexPattern: string, patternMessage: string) => string;
  // eslint-disable-next-line indent
} {
  const isEmpty = (fieldName: string, fieldValue: string) => {
    const trimmedValue = fieldValue?.trim();
    return !trimmedValue ? `${fieldName} is required` : "";
  };

  const isEmptyDate = (fieldName: string, fieldValue: Date|undefined) => {
    return !fieldValue || isNaN(fieldValue.getTime()) ? `${fieldName} is required` : "";
  };

  const isEmptyNumber = (fieldName: string, fieldValue: number) => {
    return fieldValue || fieldValue === 0 ? "" : `${fieldName} is required`;
  };

  const minLength = (fieldName: string, fieldValue: string, min: number) => {
    return fieldValue.length < min ? `${fieldName} must be atleast ${min} characters long` : "";
  };

  const isEmail = (fieldName: string, fieldValue: string) => {
    // eslint-disable-next-line operator-linebreak
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !re.test(fieldValue) ? `The email address is badly formatted` : "";
  };

  const isNum = (fieldName: string, fieldValue: string) => {
    const isNumValue = /^\d+$/.test(fieldValue);
    return !isNumValue ? `The ${fieldName} field only have numbers` : "";
  };

  const regExTest = (fieldValue: string, regexPattern: string, patternMessage: string) => {
    const regex = new RegExp(regexPattern);
    return !regex.test(fieldValue) ? patternMessage : "";
  };

  return { isEmpty, isEmptyDate, isEmptyNumber, minLength, isEmail, isNum, regExTest };
}
